// extracted by mini-css-extract-plugin
export default {"heading":"LandingHeader_heading__hofEQ","subheading":"LandingHeader_subheading__KWnyg"};